/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import { Tag, Button, Image, Upload, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import { fetchFiles } from '../../actions/FileAction';
import { uploadBanner, deleteFile } from '../../services/napi';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const Files = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const [isUploadEnabled, setUploadEnabled] = useState(true);

  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      render: (name) => {
        return (
          <div
            style={{
              color: 'black',
              fontWeight: 700
              // maxWidth: "200px",
              // textAlign: "start",
            }}
          >
            <Copy text={name} />
          </div>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
      title: 'Name'
    },
    {
      dataIndex: 'link',
      key: 'link',
      render: (link, record) => {
        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].some((ext) =>
          link.toLowerCase().endsWith(ext)
        );
        return isImage ? (
          <Image height={48} src={link} style={{ objectFit: 'contain' }} width={48} />
        ) : (
          <Tag onClick={() => window.open(link, '_blank', 'noopener noreferrer')}>Open</Tag>
        );
      },
      title: () => {
        return <div style={{ marginLeft: '50%', transform: 'translateX(-35%)' }}>Preview</div>;
      }
    },
    {
      dataIndex: 'dimensions',
      key: 'dimensions',
      render: (dimensions) => {
        return <Copy text={dimensions} />;
      },
      sorter: (a, b) => a.dimensions.localeCompare(b.dimensions),
      title: 'Dimensions'
    },
    {
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        return <Copy text={type} />;
      },
      sorter: (a, b) => a.type.localeCompare(b.type),
      title: 'File Format'
    },
    {
      dataIndex: 'updated',
      key: 'updated',
      render: (updated) => {
        return <Copy text={updated} />;
      },
      sorter: (a, b) => new Date(a.updated) - new Date(b.updated),
      title: 'Updated'
    },
    {
      dataIndex: 'link',
      key: 'link',
      render: (link) => {
        return (
          <Tag onClick={() => onClickHandler(link)} style={{ cursor: 'copy' }}>
            Copy
          </Tag>
        );
      },
      title: 'URL'
    },
    {
      dataIndex: 'link',
      key: 'status',
      render: (link) => (
        <Tag onClick={() => window.open(link, '_blank', 'noopener noreferrer')}>Open</Tag>
      )
    }
  ];

  const mapToTable = (files) => {
    const data = [];

    if (!files || files.length === 0) {
      return data;
    }

    files.forEach(({ _id, name, url, file_type, created, width, height }, index) => {
      const date = formatDate(created);
      const dimensions = width && height ? `${width} x ${height}` : '-';
      data.push({
        _id,
        dimensions,
        key: index,
        link: url,
        name,
        status: 'Active',
        type: file_type,
        updated: date
      });
    });

    return data;
  };

  const onClickHandler = (text) => {
    navigator.clipboard.writeText(text);
    const [copyModalWindow] = document.getElementsByClassName('copy-modal-window');
    copyModalWindow.classList.remove('hidden');
    setTimeout(() => {
      copyModalWindow.classList.add('hidden');
    }, 1000);
  };

  const filterData = (data) => {
    if (selectedFilter === 'All') {
      return data;
    }

    return data.filter((item) => item.contentType === selectedFilter);
  };

  const onFileDelete = async () => {
    await Promise.all(
      selectedRowKeys.map(async (index) => {
        const item = data[index];

        await deleteFile(item._id, projectId);
      })
    );

    setSelectedRowKeys([]);
    dispatch(fetchFiles());
  };

  const inputFile = useRef(null);

  const actions = [
    {
      disabled: !isUploadEnabled,
      onClick: () => inputFile.current.click(),
      style: {
        backgroundColor: '#5564F8',
        borderColor: '#5564F8',
        borderRadius: '20px',
        boxShadow: 'none',
        color: 'white',
        textShadow: 'none'
      },
      title: 'Add Media',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onFileDelete,
      style: {
        backgroundColor: 'white',
        borderColor: '#5564F8',
        borderRadius: '20px',
        boxShadow: 'none',
        color: '#5564F8',
        textShadow: 'none'
      },
      title: 'Delete',
      type: 'default'
    });
  }

  useEffect(() => {
    async function load() {
      dispatch(fetchFiles());
    }

    load();
  }, [dispatch]);

  const isLoaded = useSelector(({ file }) => file.isLoaded);
  const files = useSelector(({ file }) => file.files);

  let data = mapToTable(files);

  const filterList = ['All', ...new Set(data.map((item) => item.status))];
  const [selectedFilter, setSelectedFilter] = useState(filterList[0]);
  const onFilterChange = (value) => setSelectedFilter(value);

  data = filterData(data);

  const projectId = useSelector(({ project }) => project.currentProject._id);

  const uploadRequest = async (data) => {
    setUploadEnabled(false);
    const formData = new FormData();
    formData.append('file', data.file);

    await uploadBanner(formData, projectId);

    dispatch(fetchFiles());

    message.success(`${data.file.name} file uploaded successfully`);
    setUploadEnabled(true);
    data.onSuccess();
  };

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={files.length} title="Media" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        filter={filterList}
        loading={!isLoaded}
        onFilterChange={onFilterChange}
        selectedFilter={selectedFilter}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        title="Media"
      />
      <Upload
        customRequest={uploadRequest}
        style={{ display: 'none', height: '1px', width: '1px' }}
      >
        <Button ref={inputFile} style={{ display: 'none', height: '1px', width: '1px' }}>
          Click to Upload
        </Button>
      </Upload>
    </div>
  );
};

export default Files;
